export default __webpack_public_path__ + "static/media/06.34c1756a.svg";